import { render, staticRenderFns } from "./ChangeEmailCard.htm?vue&type=template&id=a0c021c8&scoped=true&"
import script from "./ChangeEmailCard.js?vue&type=script&lang=js&"
export * from "./ChangeEmailCard.js?vue&type=script&lang=js&"
import style0 from "./ChangeEmailCard.scss?vue&type=style&index=0&id=a0c021c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c021c8",
  null
  
)

export default component.exports